import { ApiServiceV1 } from '@services/api.service';
import JWTService from './jwt.service';

export default {
  async checkUserAuth() {
    try {
      await ApiServiceV1.get('auth/validate');
      return Promise.resolve();
    } catch (e) {
      JWTService.removeToken();
      return Promise.reject(e);
    }
  },
};
